export const tokenTypes = {
  access: 'accessToken',
  refresh: 'refreshToken'
};

export const setAccessToken = (token: string) => {
  return localStorage.setItem(tokenTypes.access, token);
};

export const setRefreshToken = (token: string) => {
  return localStorage.setItem(tokenTypes.refresh, token);
};

export const getAccessToken = () => {
  return localStorage.getItem(tokenTypes.access);
};

export const getRefreshToken = () => {
  return localStorage.getItem(tokenTypes.refresh);
};

export const setTokenExpiryTime = (dateUtcString: string) => {
  return localStorage.setItem('expiryTime', dateUtcString);
};

export const checkIfTokenExpired = () => {
  const expiryTimeString = localStorage.getItem('expiryTime') || '';

  if (!expiryTimeString) {
    return true;
  }

  const dateObj = new Date();
  const timestamp = Date.parse(expiryTimeString);
  const expiryDate = new Date(timestamp);
  if (dateObj > expiryDate) {
    return true;
  }
  return false;
};
